import React, { Component } from 'react';
import ComponentIcon from '@material-ui/icons/InsertDriveFile';

class InsertDriveFileIcon extends Component {
  render() {
    return <ComponentIcon {...this.props} />;
  }
}

export default InsertDriveFileIcon;
